import type { LocationData } from "../../../mocks/locationData";

interface LocationReviewsProps {
  location: LocationData;
}

export default function LocationReviews({ location }: LocationReviewsProps) {
  return (
    <section className="bg-cl-tint py-20 px-6 lg:px-10">
      <div className="max-w-screen-xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-xs font-black text-cl-green uppercase tracking-widest mb-2">Real Customers</p>
          <h2 className="text-3xl md:text-4xl font-black text-cl-dark leading-tight">
            What {location.city} Customers Say
          </h2>
          <p className="text-gray-500 font-semibold mt-3">
            Reviews from real jobs completed across {location.city} and surrounds
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {location.reviews.map((review, i) => (
            <div
              key={i}
              className="bg-white rounded-2xl p-5 thick-border cartoon-shadow flex flex-col"
            >
              {/* Stars */}
              <div className="flex gap-0.5 mb-3">
                {[...Array(review.rating)].map((_, j) => (
                  <i key={j} className="ri-star-fill text-[#00b67a] text-sm"></i>
                ))}
              </div>

              {/* Review text */}
              <p className="text-gray-600 text-sm font-semibold leading-relaxed flex-1 mb-4">
                &ldquo;{review.text}&rdquo;
              </p>

              {/* Reviewer */}
              <div className="flex items-center gap-3 pt-4 border-t-2 border-cl-tint">
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-cl-lime border-2 border-cl-green flex-shrink-0">
                  <span className="text-cl-dark font-black text-sm">{review.name.charAt(0)}</span>
                </div>
                <div>
                  <p className="text-cl-dark font-black text-sm">{review.name}</p>
                  <p className="text-gray-400 text-xs font-semibold">
                    {review.area} · {review.date}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Trustpilot footer */}
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <div className="flex items-center gap-3 bg-white rounded-2xl px-6 py-3.5 thick-border cartoon-shadow">
            <div className="flex gap-0.5">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-[#00b67a] text-base"></i>
              ))}
            </div>
            <span className="font-black text-cl-dark text-sm">Excellent · 4.8 / 5</span>
            <span className="text-gray-400 text-xs">·</span>
            <span className="text-gray-500 text-xs font-semibold">36,690 reviews on Trustpilot</span>
          </div>
        </div>
      </div>
    </section>
  );
}
